import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { Storage } from "@faire/web--source/common/Storage";
export var getBuilderAPIKey = function() {
    return getGlobalProperty("builderIOApiKey");
};
export var getLocaleId = function() {
    return getGlobalProperty("localeId");
};
export var getSessionCountry = function() {
    return getGlobalProperty("sessionCountry");
};
export var isE2E = function() {
    // Used in Cypress code which is outside the module
    var IS_E2E_TEST_FLAG = "IS_E2E_TEST";
    return Storage.local.getItem(IS_E2E_TEST_FLAG);
};
